/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const file_warning_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5 5h5.5M5 8h8.5M5 19h2.5m11-10.5v-.634a1 1 0 0 0-.237-.646L13.3 1.354A1 1 0 0 0 12.536 1H2.5a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1H7m9.8-4.577V15.61m-.023 4.915h.023m5.994-.126a1.801 1.801 0 0 1-.08 1.765 1.842 1.842 0 0 1-1.556.861h-8.716a1.84 1.84 0 0 1-1.557-.86 1.8 1.8 0 0 1-.078-1.766l4.356-7.62a1.82 1.82 0 0 1 .675-.733 1.84 1.84 0 0 1 2.598.732l4.358 7.62Z"
    />
  </svg>
)
export default file_warning_medium
